"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var __1 = require("..");
var classnames_1 = __importDefault(require("classnames"));
var InputLabel_1 = require("./InputLabel");
var defaultProps = {
    size: 'fit',
    iconPosition: 'left',
    variant: 'boxed',
};
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var borderRadius = _a.borderRadius, colors = _a.colors;
    return ({
        inputWrap: {
            display: 'inline-flex',
            flexDirection: 'column',
            position: 'relative',
        },
        description: {
            paddingTop: 7,
        },
        error: {
            color: colors.Red[600],
        },
        base: {
            fontFamily: 'inherit',
            color: colors.Grey[900],
            width: '100%',
        },
        input: function (styles) { return (__assign({ padding: '10px 11px 11px', fontSize: 14, border: "1px solid ".concat(colors.Grey[500]), boxSizing: 'border-box', borderRadius: borderRadius.sm, '&::placeholder': {
                color: "".concat(colors.Grey[500]),
            }, '&:focus, &:focus-visible': {
                boxShadow: 'none',
                outline: 'none',
                borderColor: colors.Hannibal[600],
                backgroundColor: colors.Hannibal[100],
            } }, styles)); },
        valid: function () { return ({
            borderColor: colors.Green[600],
        }); },
        hasIcon: {
            '& $input': {
                paddingLeft: 32,
            },
        },
        stretch: {
            width: '100%',
        },
        icon: {
            position: 'absolute',
            top: 12,
            left: 10,
            pointerEvents: 'none',
            maxWidth: 12,
            maxHeight: 12,
        },
        iconRight: {
            '& $icon': {
                left: 'auto',
                right: 13,
            },
            '& $input': {
                paddingLeft: 11,
                paddingRight: 32,
            },
        },
        borderless: {
            fontSize: 30,
            border: 'none',
            padding: 0,
            '&:focus': {
                outline: 'none',
            },
            '&::placeholder': {
                color: "".concat(colors.Grey[400]),
            },
        },
        boxedErrored: {
            borderColor: colors.Red[600],
        },
        borderlessErrored: {
            '&::placeholder': {
                color: "".concat(colors.Red[600]),
            },
        },
    });
});
var InputMessage = function (_a) {
    var _b;
    var error = _a.error, children = _a.children;
    var styles = useStyles();
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.description, (_b = {},
            _b[styles.error] = error,
            _b)) },
        react_1.default.createElement(__1.Typography, { variant: "textSmall" }, children)));
};
var Input = function (props, ref) {
    var _a, _b, _c;
    var onChange = props.onChange, style = props.style, placeholder = props.placeholder, errorText = props.errorText, size = props.size, error = props.error, icon = props.icon, label = props.label, iconPosition = props.iconPosition, required = props.required, variant = props.variant, className = props.className, component = props.component, description = props.description, id = props.id, rest = __rest(props, ["onChange", "style", "placeholder", "errorText", "size", "error", "icon", "label", "iconPosition", "required", "variant", "className", "component", "description", "id"]);
    var classes = useStyles(style);
    var Tag = component ? component : 'input';
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)((_a = {},
            _a[classes.stretch] = size === 'stretch',
            _a)) },
        label && (react_1.default.createElement(InputLabel_1.InputLabel, { required: required, id: id }, label)),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.inputWrap, (_b = {},
                _b[classes.stretch] = size === 'stretch',
                _b[classes.hasIcon] = !!icon,
                _b[classes.iconRight] = iconPosition === 'right',
                _b)) },
            react_1.default.createElement(Tag, __assign({ ref: ref, required: required, placeholder: placeholder, className: (0, classnames_1.default)(classes.base, className, (_c = {},
                    _c[classes.input] = variant === 'boxed',
                    _c[classes.boxedErrored] = variant === 'boxed' && error,
                    _c[classes.valid] = error === false,
                    _c[classes.borderless] = variant === 'borderless',
                    _c[classes.borderlessErrored] = variant === 'borderless' && error,
                    _c)), onChange: onChange }, rest)),
            !!errorText && error && (react_1.default.createElement(InputMessage, { error: true }, errorText)),
            !!description && !error && react_1.default.createElement(InputMessage, null, description),
            icon && (0, react_1.isValidElement)(icon)
                ? (0, react_1.cloneElement)(icon, {
                    className: classes.icon,
                })
                : icon)));
};
var ForwardedInput = (0, react_1.forwardRef)(Input);
ForwardedInput.defaultProps = defaultProps;
var Textarea_1 = require("./Textarea");
Object.defineProperty(exports, "Textarea", { enumerable: true, get: function () { return __importDefault(Textarea_1).default; } });
exports.default = ForwardedInput;
//# sourceMappingURL=index.js.map